
export default {
    name: 'ZonarIcon',
};
